export default "__VITE_ASSET__C47VZQCQ__"